import freightNo from '../resources/no/freight.json';
import freightSe from '../resources/se/freight.json';
import { FreightLanguageResources } from '../types/FreightResources';

export const freightI18nResources: FreightLanguageResources = {
  no: { freight: freightNo },
  se: { freight: freightSe },
};
